const DateFormat = (date?: Date | string): string => {
  let parsedDate: Date;
  if (!date) {
    parsedDate = new Date();
  } else if (typeof date === "string") {
    parsedDate = new Date(date);
  } else {
    parsedDate = date;
  }
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };
  return parsedDate.toLocaleString("en-US", options);
};
export default DateFormat;
